import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import { APIURL, TZ } from '../../../../Global';
import sampleList from '../sampleList';
import { useAlert } from 'react-alert';

const AddGroup = (props) => {
    const [group, setGroup] = useState(props.groupData?.name);
    const [note, setNote] = useState(props.groupData?.description);
    const [error, setError] = useState('')
    const alert = useAlert();




    const handleSubmit = () => {
        if (!group || group === '') {
            setError('Group name is mandatory');
            return;
        }

        const payload = {
            ...(props.groupData && { group_id: props.groupData.id }),
            group_name: group,
            description: note,
        };

        const tokenString = sessionStorage.getItem('usertoken');
        const str = tokenString?.replace(/["]+/g, '');

        const baseUrl = props.from === 'clinic'
            ? `${APIURL}/api/v1/staff/hospital-group/`
            : `${APIURL}/api/v1/staff/lab-test/`;

        const isUpdate = Boolean(props.groupData);
        const url = isUpdate
            ? `${baseUrl}?group_id=${props.groupData.id}/?${TZ}`
            : `${baseUrl}?${TZ}`;

        const request = isUpdate
            ? axios.put(url, payload, {
                headers: { Authorization: 'Token ' + str }
            })
            : axios.post(url, payload, {
                headers: { Authorization: 'Token ' + str }
            });

        request
            .then((res) => {
                if (res.status === 200 && res.data.status === 'success') {
                    alert.success(isUpdate ? 'Group updated successfully!' : 'Group added successfully!');
                    props.handleSuccess();
                } else {
                    alert.error(res.data.message ||
                        (isUpdate ? 'Failed to update group.' : 'Failed to add group.'));
                }
            })
            .catch((err) => {
                alert.error(isUpdate
                    ? 'Failed to update group. Please try again.'
                    : 'Failed to add group. Please try again.');
                console.error('API Error:', err);
            });
    };

    return (
        <div>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                show={true}
            >
                <Modal.Body >
                    <div className="add-cont colflex-display col-12">
                        <label className="addcont-head">Add Group</label>
                        <hr style={{ border: "1px solid #ccc", marginTop: 0 }} />
                        <div className={`pricing-inputcontainer ${error !== "" ? "error-inputcontainer" : ""}`}>
                            <span>Group Name <span style={{ color: "red" }}>*</span></span>
                            <input
                                name="name"
                                placeholder={'name'}
                                value={group}
                                onChange={(e) => { setGroup(e.target.value); setError('') }}
                            />
                            {error && <label>{error}</label>}
                        </div>
                        <div className='pricing-inputcontainer'>
                            <span>Description</span>
                            <input
                                name="note"
                                placeholder='description'
                                value={note}
                                onChange={(e) => { setNote(e.target.value) }}
                            />
                        </div>
                        <div style={{ justifyContent: "end", gap: "10px", display: "flex" }}>
                            <button className='add-btn' style={{ width: "fit-content", padding: "5px 25px" }} onClick={props.onClose}>
                                Cancel
                            </button>
                            <button className='add-btn' style={{ width: "fit-content", padding: "5px 25px" }} onClick={handleSubmit}>
                                Save
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default AddGroup;
